import { useState, useEffect, useCallback } from "react";

function useTimerThreshold(thresholdInSeconds = 0, initialStartTime = Date.now()) {
  const [startTime, setStartTime] = useState(initialStartTime);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (thresholdInSeconds === 0) {
      setIsExpired(false);
      return () => {};
    }
    
    const interval = setInterval(() => {
      const elapsedSeconds = (Date.now() - startTime) / 1000;
      setIsExpired(elapsedSeconds > thresholdInSeconds);
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, thresholdInSeconds]);

  const resetTimer = useCallback((newStartTime = Date.now()) => {
    setStartTime(newStartTime);
    setIsExpired(false);
  }, []);

  return { isExpired, resetTimer };
}

export default useTimerThreshold;